import React from "react";
import heroImage from "../../assets/home.jpg"; // adjust path if needed

export default function Hero() {
  return (
    <section id="home" className="heroSection">
      <div className="heroBackground">
        <img
          src={heroImage}
          alt="Dairy farm with cows grazing in a beautiful countryside setting"
          className="heroImage"
        />
        <div className="heroOverlay" />
      </div>

      <div className="heroContent">
        <h1 className="heroTitle">Pure & Fresh Milk Delivered to Your Doorstep</h1>
        <p className="heroSubtitle">Fresh from our cows, every morning | evening.</p>
        <button className="heroButton">Learn More</button>
      </div>
    </section>
  );
}
